import BetterLuckNextSVg from "@Assets/svg/Dashboard-svgs/Better-luck-next.svg";
import RankedCrownSvg from "@Assets/svg/Dashboard-svgs/Rankedcrown.svg";
import OverallscoreSvg from "@Assets/svg/Dashboard-svgs/Overallscore.svg";
import AttemptsSvg from "@Assets/svg/Dashboard-svgs/Attempts.svg";
import TimeSvg from "@Assets/svg/Dashboard-svgs/Time.svg";
import PassSvg from "@Assets/svg/Dashboard-svgs/Pass.svg";
import { AppRouteURL, TestRouteURL, TestSereisRouteURL } from "@Constants/app-route-url.constant";
import { Link, useNavigate } from "react-router-dom";
import SvgIcon from '@Components/icons/SvgIcon';
import { getExamDetails } from "@Src/features/Dashboard/Service/Dashboard.service";
import { APIStatus } from "@Src/services/baseInterfaces";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTrendUp, faPlus } from "@fortawesome/free-solid-svg-icons";
import { NoSubscriptionDialog } from "@Components/NoSubscriptionDialog/NoSubscriptionDialog";
import { useSubscriptionNavigation } from "@Src/hooks/useSubscriptionNavigation";
import { TestTypes } from "@Constants/app.constant";
import { Dialog } from "primereact/dialog";
import { useAppSelector } from "@Src/app/hooks";
import { useTranslation } from "react-i18next";

export const LeaderboardResult = ({ testType, resultdata, LeaderDetails, userValueId, examId, testId, TimeValue, examType, userTestId, subjectList, classList, duration, testseriesId, chapterTopics, Reviewdata, boardName, testName }: any) => {
    const navigation = useNavigate()
    // const [subjectList, setSubjectList] = React.useState<string[]>([]);
    // const [classList, setClassList] = React.useState<string[]>([]);
    // const [duration, setDuration] = React.useState<any>();
    // const [testseriesId, setTestSeriesId] = React.useState<any>();
    const [isChaptersExpanded, setIsChaptersExpanded] = React.useState(false);
    const [showExpandButton, setShowExpandButton] = React.useState(false);
    // const [chapterTopics, setChapterTopics] = React.useState<any>();
    const chaptersRef = React.useRef<HTMLDivElement>(null);

    const { checkSubscriptionAndNavigate, subscriptionDialogProps, pendingTestDialogProps } = useSubscriptionNavigation()
    const navigate = useNavigate();
    const coursePreferences = useAppSelector((state: any) => state.coursePreferences);
    const { t } = useTranslation("common");

    const onClickRetry = (testID: number, testtype: number, testDuration: number, testSeriesId: number, examType: number) => {
        let targetUrl = '';
        let stateTransfer: any = {};
        if (testtype == TestTypes.regular) {
            if (examType === 1) {
                if (testSeriesId) {
                    targetUrl = `${TestSereisRouteURL.FULL_MOCK_TEST_SERIES}/${testSeriesId}`;
                    stateTransfer = { flagTest: testSeriesId }
                }
            } else if (examType === 3) {
                if (testSeriesId) {
                    targetUrl = `${TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES}/${testSeriesId}`;
                    stateTransfer = { flagTest: testSeriesId }
                }
            }
            else {
                if (testSeriesId) {
                    targetUrl = `${TestRouteURL.TEST_SERIES}/${testSeriesId}`;
                    stateTransfer = { flagTest: testSeriesId }
                } else {
                    targetUrl = `${TestRouteURL.TEST}/${testID}`;
                    stateTransfer = { flagTest: testID }
                }
            }

        } else if (testtype == TestTypes.speed) {
            if (examType === 2) {
                if (testSeriesId) {
                    targetUrl = `${TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES}/${testSeriesId}`;
                    stateTransfer = { flagTest: testSeriesId, duration: testDuration }
                }
            } else {
                if (testSeriesId) {
                    targetUrl = `${TestRouteURL.SPEED_TEST_SERIES}/${testSeriesId}`;
                    stateTransfer = { flagTest: testSeriesId, duration: testDuration }
                } else {
                    targetUrl = `${TestRouteURL.SPEED_TEST}/${testID}`;
                    stateTransfer = { flagTest: testID, duration: testDuration }
                }
            }


        }
        checkSubscriptionAndNavigate(targetUrl, undefined, stateTransfer, false);
    }

    const rankvalue = LeaderDetails.findIndex((detail: any) => {
        return LeaderDetails ? detail.userId === userValueId : ''
    })

    const TestResultPercent = ((resultdata[0]?.['positiveMarks'] - resultdata[0]?.['negativeMarks']) / (resultdata[0]?.['totalMarks'])) * 100

    const navigateToLeaderBoard = () => {
        if (examId) {
            // navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.LEADEBOARD}/${userValueId}?examId=${examId}&testType=${testType}${examType === 2 ? "&examType=2" : ""}`)
            navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.LEADEBOARD}/${userValueId}`, { state: { examId: examId, testType: testType, examType: examType === 2 ? "2" : (examType === 1 ? "1" : (examType === 3 ? "3" : "")) } })
        } else {
            // navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.LEADEBOARD}/${userValueId}?testId=${testId}&testType=${testType}${examType === 2 ? "&examType=2" : ""}`)
            navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.LEADEBOARD}/${userValueId}`, { state: { testId: testId, testType: testType, examType: examType === 2 ? "2" : (examType === 1 ? "1" : (examType === 3 ? "3" : "")) } })
        }
    }
    // const fetchExamDetails = () => {
    //     getExamDetails({ examId: examId.toString() }).then((response: any) => {
    //         if (response.ResponseType === APIStatus.SUCCESS && response.data) {
    //             const sortedSubjects = (response.data.SubjectList || []).slice().sort((a: string, b: string) => a.toLowerCase().localeCompare(b.toLowerCase()));
    //             const sortedClasses = (response.data.ClassList || []).slice().sort((a: string, b: string) => a.toLowerCase().localeCompare(b.toLowerCase()));
    //             setSubjectList(sortedSubjects);
    //             setClassList(sortedClasses);
    //             setDuration(response.data.Duration)
    //             setTestSeriesId(response.data.Id)
    //             setChapterTopics(response.data.ChapterList)
    //         }
    //     }).catch((error: any) => {
    //         console.log(error)
    //     })
    // }
    // React.useEffect(() => {
    //     fetchExamDetails()
    // }, [examId])

    React.useEffect(() => {
        const checkOverflow = () => {
            if (chaptersRef.current) {
                const element = chaptersRef.current;

                // Store current styles to restore them later
                const originalWebkitLineClamp = element.style.webkitLineClamp;
                const originalMaxHeight = element.style.maxHeight;
                const originalDisplay = element.style.display;

                // Force collapsed state to measure
                element.style.webkitLineClamp = '1';
                element.style.maxHeight = '1.5em';
                element.style.display = '-webkit-box';

                const isOverflowing = element.scrollHeight > element.clientHeight;
                setShowExpandButton(isOverflowing);

                // Restore styles
                element.style.webkitLineClamp = originalWebkitLineClamp;
                element.style.maxHeight = originalMaxHeight;
                element.style.display = originalDisplay;
            }
        };

        const timer = setTimeout(checkOverflow, 100);
        window.addEventListener('resize', checkOverflow);
        return () => {
            clearTimeout(timer);
            window.removeEventListener('resize', checkOverflow);
        };
    }, [resultdata, isChaptersExpanded]); // Added isChaptersExpanded to re-check if needed, though restoration logic helps


    const incorrects = (resultdata[0]?.['incorrectAns'])
    const attempts = (resultdata[0]?.['attendQuestion'])
    const accuracy = (resultdata[0]?.['attendQuestion']) > 0 ? ((resultdata[0]?.['correctAns'] / (resultdata[0]?.['attendQuestion'])) * 100).toFixed(2) : Number(0).toFixed(2);
    const attemptRate = resultdata[0]?.['NoOfQuestion'] ? ((resultdata[0]?.['attendQuestion'] / resultdata[0]?.['NoOfQuestion']) * 100) : 0
    const correctRate = (resultdata[0]?.['attendQuestion']) > 0 ? ((resultdata[0]?.['correctAns'] / resultdata[0]?.['attendQuestion']) * 100) : 0
    const incorrectRate = (resultdata[0]?.['attendQuestion']) > 0 ? ((resultdata[0]?.['incorrectAns'] / resultdata[0]?.['attendQuestion']) * 100) : 0

    const score = resultdata[0]?.['scoreInPercentage'] ? resultdata[0]?.['scoreInPercentage'] : 0
    const timeUtilization = ((resultdata[0]?.['UsedDuration']) / duration) * 100

    const avgTimeSum = Reviewdata.reduce((sum: any, item: any) => sum + item.AvgTime, 0);


    const formatPercent = (num: number) => {
        return Number.isInteger(num) ? num.toString() : num.toFixed(2);
    };


    const getAttemptedMessage = () => {
        if (Number(attemptRate) > 75) {
            return <div className="tw-text-green-500 text-sm "> {t("good_attempt_rate")}</div>
        } else if (Number(attemptRate) >= 50 && Number(attemptRate) <= 75) {
            return <div className="tw-text-yellow-500 text-sm "> {t("moderate_attempt_rate")}</div>
        } else if (Number(attemptRate) >= 30 && Number(attemptRate) < 50) {
            return <div className="tw-text-orange-500 text-sm tw-flex gap-2"><SvgIcon name="alert" size={20} />
                {t("need_to_improve_attempt_rate")}</div>
        } else if (Number(attemptRate) < 30) {
            return <div className="tw-text-red-500 text-sm tw-flex gap-2"><span className="tw-pb-0 tw-text-red-400"><SvgIcon name="alert" size={20} /></span> {t("attempt_more_questions")}</div>
        }
    }

    const getCorrectMessage = () => {
        if (Number(correctRate) > 75) {
            return <div className="tw-text-green-500 text-sm "> {t("good_correct_rate")}</div>
        } else if (Number(correctRate) >= 50 && Number(correctRate) <= 75) {
            return <div className="tw-text-yellow-500 text-sm "> {t("moderate_correct_rate")}</div>
        } else if (Number(correctRate) >= 30 && Number(correctRate) < 50) {
            return <div className="tw-text-orange-500 text-sm tw-flex gap-2"><SvgIcon name="alert" size={20} /> {t("need_to_improve_correct_rate")}</div>
        } else if (Number(correctRate) < 30) {
            return <div className="tw-text-red-500 text-sm tw-flex gap-2"><span className="tw-pb-0 tw-text-red-400"><SvgIcon name="alert" size={20} /></span> {t("try_to_correct_more_answers")}</div>
        }
    }
    const getIncorrectMessage = () => {
        if (Number(incorrectRate) > 75) {
            return <div className="tw-text-red-500 text-sm tw-flex gap-2"><span className="tw-pb-0 tw-text-red-400"><SvgIcon name="alert" size={20} /></span> {t("concept_gaps_detected")}</div>
        } else if (Number(incorrectRate) >= 50 && Number(incorrectRate) <= 75) {
            return <div className="tw-text-orange-500 text-sm tw-flex gap-2"><SvgIcon name="alert" size={20} />{t("need_to_improve_concept_gaps")}</div>
        } else if (Number(incorrectRate) >= 30 && Number(incorrectRate) < 50) {
            return <div className="tw-text-yellow-500 text-sm ">{t("your_concepts_are_getting_cleared")}</div>
        } else if (Number(incorrectRate) < 30) {
            return <div className="tw-text-green-500 text-sm ">{t("good_your_incorrect_rate_is_low")}</div>
        }
    }


    const getTimeMessage = () => {
        // if ((resultdata[0]?.['UsedDuration']) < (duration / 2)) {
        //     return <div className="tw-text-rose-500 text-sm ">You're rushing → causing mistakes</div>
        // } else {
        //     return <></>
        // }
        if (timeUtilization > 50 && timeUtilization <= 100 && testType === 2 && avgTimeSum < (resultdata[0]?.['UsedDuration'])) {
            return <div className="tw-text-rose-500 text-sm ">{t("you_can_attempt_more_questions")}</div>
        } else if (timeUtilization >= 85 && timeUtilization <= 100) {
            if (Number(score) >= 85) {
                return <div className="tw-text-rose-500 text-sm ">{t("you_have_taken_proper_time_to_answer")}</div>
            } else if (Number(score) >= 50 && Number(score) < 85) {
                return <div className="tw-text-rose-500 text-sm ">{t("you_should_utilize_the_time_properly")}</div>
            } else if (Number(score) < 50) {
                return <div className="tw-text-rose-500 text-sm ">{t("your_time_usage_is_good_but_your_approach_needs_improvement")}</div>
            }
        } else if (timeUtilization >= 70 && timeUtilization < 85) {
            if (Number(score) >= 85) {
                return <div className="tw-text-rose-500 text-sm ">{t("you_are_utilizing_the_time_properly")}</div>
            } else if (Number(score) >= 50 && Number(score) < 85) {
                return <div className="tw-text-rose-500 text-sm ">{t("you_should_utilize_the_time_properly_for_better_result")}</div>
            } else if (Number(score) < 50) {
                return <div className="tw-text-rose-500 text-sm ">{t("your_time_management_needs_improvement")}</div>
            }
        } else if (timeUtilization >= 40 && timeUtilization < 70) {
            if (Number(score) >= 85) {
                return <div className="tw-text-rose-500 text-sm ">{t("you_performed_well")}</div>
            } else if (Number(score) >= 50 && Number(score) < 85) {
                return <div className="tw-text-rose-500 text-sm ">{t("you_should_utilize_the_time_properly_for_better_result")}</div>
            } else if (Number(score) < 50) {
                return <div className="tw-text-rose-500 text-sm ">{t("you_are_not_utilizing_the_time_properly")} {Number(accuracy) < 100 ? t("causing_mistakes") : ""}</div>
            }
        } else if (timeUtilization < 40) {
            if (Number(score) >= 85) {
                return <div className="tw-text-rose-500 text-sm ">{t("your_score_is_good")}</div>
            } else if (Number(score) >= 50 && Number(score) < 85) {
                return <div className="tw-text-rose-500 text-sm ">{t("you_should_utilize_the_time_properly_for_better_result")}</div>
            } else if (Number(score) < 50) {
                return <div className="tw-text-rose-500 text-sm ">{t("you_are_rushing")} {Number(accuracy) < 100 ? t("causing_mistakes") : t("through_questions")}</div>
            }
        }
    }

    const getScoreMessage = () => {
        if (Number(accuracy) > 75) {
            return <div className="tw-text-green-500 text-sm ">{t("you_have_a_very_great_accuracy")}</div>
        } else if (Number(accuracy) >= 50 && Number(accuracy) <= 75) {
            return <div className="tw-text-yellow-500 text-sm ">{t("you_need_just_a_little_more_improvement_in_accuracy")}</div>
        } else if (Number(accuracy) >= 30 && Number(accuracy) < 50) {
            return <div className="tw-text-orange-500 text-sm ">{t("accuracy_is_your_biggest_improvement_area")}</div>
        } else if (Number(accuracy) < 30) {
            return <div className="tw-text-red-500 text-sm ">{t("you_have_a_very_low_accuracy")}</div>
        }
    }

    const getPerformanceAdvice = () => {
        if (Number(score) > 75) {
            return <>
                <div className="tw-text-green-500 text-lg ">{t("strong_performance")}</div>
                <div className="tw-text-gray-700 text-sm tw-mt-2 tw-font-normal">{t("fine_tune")}</div>
            </>
        } else if (Number(score) >= 50 && Number(score) <= 75) {
            return <>
                <div className="tw-text-yellow-500 text-lg ">{t("good_progress")}</div>
                <div className="tw-text-gray-700 text-sm tw-mt-2 tw-font-normal">{t("improve_accuracy_and_speed")}</div>
            </>
        } else if (Number(score) >= 30 && Number(score) < 50) {
            return <>
                <div className="tw-text-orange-500 text-lg ">{t("you’re_on_the_right_track")}</div>
                <div className="tw-text-gray-700 text-sm tw-mt-2 tw-font-normal">{t("fix_your_weak_areas")}</div>
            </>
        } else if (Number(score) < 30) {
            return <>
                <div className="tw-text-red-500 text-lg ">{t("your_score_can_improve")}</div>
                <div className="tw-text-gray-700 text-sm tw-mt-2 tw-font-normal">{t("low_accuracy_is_holding_you_back")}</div>
            </>
        }
    }
    const getAccuracyInsight = () => {
        if (Number(accuracy) >= 70 && Number(accuracy) < 100) {
            if (timeUtilization >= 80 && timeUtilization <= 95) {
                return <li  >{t("only_minor_mistakes")}</li>
            } else {
                return <>
                    <li  >{t("silly_mistakes")}</li>
                    {getTimeInsight()}
                </>
            }

        } else if (Number(accuracy) > 50 && Number(accuracy) < 70) {
            return <> <li>{t("more_silly_mistakes")}</li>
                {getTimeInsight()}
            </>
        } else if (Number(accuracy) === 50) {
            return <>
                <li  >{t("moderate_accuracy")} {formatPercent(Number(accuracy))}%</li>
                {getTimeInsight()}
            </>
        } else if (Number(accuracy) < 50) {
            if (timeUtilization > 80) {
                return <li>{t("mistakes_are_happening")}</li>
            } else if (Number(accuracy) >= 30) {
                return <>
                    <li  >{t("low_level_accuracy")} {formatPercent(Number(accuracy))}%</li>
                    {getTimeInsight()}
                </>
            } else if (Number(accuracy) < 30) {
                return <>
                    <li >{t("very_low_accuracy")} {formatPercent(Number(accuracy))}%</li>
                    {getTimeInsight()}
                </>
            }

        }
    }
    const getIncorrectInsight = () => {
        if (timeUtilization < 60 && Number(incorrectRate) > 50) {
            return <>
                <li>{t("you_are_rushing_through_questions")}</li>
            </>
        } else if (Number(incorrectRate) > 75) {
            return <>
                <li  >{incorrects > (attempts / 2) ? t("higher_number_of_incorrect_answers") : t("high_incorrect_rate")}</li>
                <li  >{t("concepts_are_not_cleared")}</li>
            </>
        } else if (Number(incorrectRate) > 50 && Number(incorrectRate) <= 75) {
            return <>
                <li>{t("high_incorrect_rate")}</li>
                <li  >{t("weak_conceptual_understanding")}</li>
            </>
        } else if (Number(incorrectRate) === 50) {
            return <>
                <li>{t("moderate_incorrect_rate")}</li>
                <li >{t("gaps_in_concepts")}</li>
            </>
        } else if (Number(incorrectRate) >= 30 && Number(incorrectRate) < 50) {
            return <li  >{t("few_incorrect_answers")}</li>
        } else if (Number(incorrectRate) < 30 && Number(incorrectRate) > 0) {
            return <li >{t("few_incorrect_answers")}</li>
        }
    }
    const getSkipInsight = () => {
        if (Number(attemptRate) >= 90 && Number(accuracy) < 40) {
            return <li>{t("incorrect_answers_are_coming_from_guesswork")}</li>
        } else if (Number(attemptRate) > 60 && Number(attemptRate) < 90) {
            return <li>{t("few_skipped_questions_that_might_boost_your_score")}</li>
        } else if (Number(attemptRate) <= 60) {
            if (timeUtilization > 90) {
                return <li>{t("you_are_overthinking_and_getting_stuck_on_questions")}</li>
            } else if (Number(attemptRate) >= 50) {
                return <li>{t("moderate_skip_rate")}</li>
            } else if (Number(attemptRate) >= 30 && Number(attemptRate) < 50) {
                return <li>{t("high_number_of_skipped_questions")}</li>
            } else if (Number(attemptRate) < 30 && Number(attemptRate) > 0) {
                return <li>{t("too_high_skip_rate")}</li>
            } else if (Number(attemptRate) === 0) {
                return <li>{t("attempt_questions")}</li>
            }
        }
    }
    const getTimeInsight = () => {
        if (Number(timeUtilization) < 85) {
            return <>
                <li>{t("time_utilization_issue_detected")}</li>
                {/* <li>Attempted in {formatPercent(Number(timeUtilization))}% of allotted time → {Number(accuracy) >= 50 ? "Causing errors" : "High error rate"}</li> */}
                <li>{t("attempted_in_time", { percent: formatPercent(Number(timeUtilization)) })} → {Number(accuracy) >= 50 ? t("causing_errors") : t("high_error_rate")}</li>
            </>
        }
    }

    const getInsights = () => {
        if (Number(score) > 75 && !(TestResultPercent === 100)) {
            return <>
                <ul style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    {!(Number(attemptRate) === 0) ? getAccuracyInsight() : <></>}
                    {getIncorrectInsight()}
                    {testType === 1 ? getSkipInsight() : (Number(attemptRate) === 0 ? <li>{t("attempt_questions")}</li> : <></>)}

                </ul>
            </>
        } else if (Number(score) >= 50 && Number(score) <= 75) {
            return <>
                <ul style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    {!(Number(attemptRate) === 0) ? getAccuracyInsight() : <></>}
                    {getIncorrectInsight()}
                    {testType === 1 ? getSkipInsight() : Number(attemptRate) === 0 ? <li>{t("attempt_questions")}</li> : <></>}


                </ul>
            </>
        } else if (Number(score) >= 30 && Number(score) < 50) {
            return <>
                <ul style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    {!(Number(attemptRate) === 0) ? getAccuracyInsight() : <></>}
                    {getIncorrectInsight()}
                    {testType === 1 ? getSkipInsight() : Number(attemptRate) === 0 ? <li>{t("attempt_questions")}</li> : <></>}


                </ul>
            </>
        } else if (Number(score) < 30) {
            return <>

                <ul style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    {!(Number(attemptRate) === 0) ? getAccuracyInsight() : <></>}
                    {getIncorrectInsight()}
                    {/* <li> Weak conceptual understanding </li> */}
                    {testType === 1 ? getSkipInsight() : Number(attemptRate) === 0 ? <li>{t("attempt_questions")}</li> : <></>}


                </ul>
            </>
        } else if (TestResultPercent === 100) {
            return <>
                <ul style={{ listStyleType: "disc", marginLeft: "20px" }}>
                    <li> {t("perfect_score")} ({TestResultPercent}%)</li>
                    <li> {t("efficient_answering")} </li>
                    <li> {t("strong_conceptual_understanding")} </li>
                </ul>
            </>
        }
    }

    const getDuration = (durationdata: any) => {
        let hours: any = Math.floor(durationdata / 3600);
        let minutes: any = Math.floor((durationdata - (hours * 3600)) / 60);
        let seconds: any = durationdata - (hours * 3600) - (minutes * 60);

        if (hours > 0) {
            hours = (hours < 10) ? "0" + hours : hours;
        } else {
            hours = '';
        }
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;
        let time = hours + (hours ? ":" : '') + minutes + ":" + seconds
        return time;
    }


    const formatScore = (value: any) => {
        const num = Number(value);
        if (isNaN(num)) return 0;
        return num % 1 === 0 ? num : num.toFixed(2);
    };

    const navigateToMindMap = () => {
        let formattedSubjectList: any[] = [];
        let formattedChapterList: any[] = [];
        let formattedTopicList: any[] = [];

        if (subjectList && subjectList.length > 0) {
            formattedSubjectList = subjectList.map((s: any) => ({
                Id: s.id ?? s.Id ?? s.subjectId ?? s.SubjectId,
                Name: s.name ?? s.Name ?? s.subjectName ?? s.SubjectName ?? (typeof s === 'string' ? s : '')
            })).filter((s: any) => s.Id || s.Name);
        } else if (resultdata?.[0]?.chapters && resultdata[0].chapters.length > 0) {
            const uniqueSubjects = new Map<any, any>();
            resultdata[0].chapters.forEach((c: any) => {
                const id = c.subjectId ?? c.SubjectId ?? c.id ?? c.Id;
                const name = c.subjectName ?? c.SubjectName ?? c.name ?? c.Name;
                if (id && !uniqueSubjects.has(id)) {
                    uniqueSubjects.set(id, { Id: id, Name: name });
                }
            });
            formattedSubjectList = Array.from(uniqueSubjects.values());
        }

        if (chapterTopics && chapterTopics.length > 0) {
            formattedChapterList = chapterTopics.map((c: any) => ({
                Id: c.chapterId ?? c.ChapterId ?? c.id ?? c.Id,
                Name: c.chapter ?? c.ChapterName ?? c.name ?? c.Name
            })).filter((c: any) => c.Id || c.Name);

            formattedTopicList = chapterTopics.flatMap((c: any) => {
                return (c.topics || []).map((t: any) => ({
                    Id: t.topicId ?? t.TopicId ?? t.id ?? t.Id,
                    Name: t.topic ?? t.TopicName ?? t.name ?? t.Name ?? (typeof t === 'string' ? t : '')
                })).filter((t: any) => t.Id || t.Name);
            });
        } else if (resultdata?.[0]?.chapters && resultdata[0].chapters.length > 0) {
            const uniqueChapters = new Map<any, any>();
            const uniqueTopics = new Map<any, any>();

            resultdata[0].chapters.forEach((c: any) => {
                const id = c.chapterId ?? c.ChapterId ?? c.id ?? c.Id;
                const name = c.chapterName ?? c.ChapterName ?? c.chapter ?? c.name ?? c.Name;
                if (id && !uniqueChapters.has(id)) {
                    uniqueChapters.set(id, { Id: id, Name: name });
                }

                (c.topics || []).forEach((t: any) => {
                    const topicId = typeof t === 'object' ? (t.topicId ?? t.TopicId ?? t.id ?? t.Id) : undefined;
                    const topicName = typeof t === 'object' ? (t.topicName ?? t.TopicName ?? t.topic ?? t.name ?? t.Name) : t;
                    const key = topicId ?? topicName;
                    if (key && !uniqueTopics.has(key)) {
                        uniqueTopics.set(key, { Id: topicId ?? key, Name: topicName });
                    }
                });
            });

            formattedChapterList = Array.from(uniqueChapters.values());
            formattedTopicList = Array.from(uniqueTopics.values());
        }

        navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.MIND_MAP}`, {
            state: {
                subjectList: formattedSubjectList,
                chapterList: formattedChapterList,
                topicList: formattedTopicList,
                returnFromResulPage: 1,
            }
        });
    };

    return (
        <>
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-5 tw-items-start tw-justify-between mb-3 ">
                <div className="tw-col-span-1 md:tw-col-span-4 mb-2">

                    <div className="test-paper-name">{testName} <span className="tw-inline-flex tw-items-center px-3  tw-border tw-border-grey-800 tw-rounded-3xl tw-mx-2 mb-2" style={{ fontSize: "14px", background: "#F3F0FF", color: "#7A68E0" }}>
                        {examType === 2 ? "Readiness Check" : (examType === 1 ? "Mock" : (examType === 3 ? "Previous Year" : (testType === 1 ? 'Practice Smart' : 'Speed Test')))}
                    </span></div>
                    {resultdata[0] && (boardName || resultdata[0].className || resultdata[0].subjectName) && (
                        <div className="tw-text-sm tw-font-bold tw-mt-1">
                            {boardName && <span style={{ color: '#7A68E0' }}>{boardName}</span>}
                            {boardName && (classList.length > 0 || subjectList.length > 0) && <span className="tw-mr-1">,</span>}
                            {classList.length > 0 && (
                                <span style={{ color: '#7A68E0' }}>
                                    Class {classList.join(', ')}
                                </span>
                            )}
                            {classList.length > 0 && subjectList.length > 0 && <span className="tw-mr-1">,</span>}
                            {subjectList.length > 0 && (
                                <span style={{ color: '#7A68E0' }}>
                                    {subjectList.map((subject: any) => subject?.name).slice().sort((a: string, b: string) => a.toLowerCase().localeCompare(b.toLowerCase())).join(', ')}
                                </span>
                            )}
                        </div>


                    )}
                    {chapterTopics && chapterTopics.length > 0 && (
                        <div className="tw-text-sm tw-font-medium tw-text-gray-500 tw-mt-1">
                            <div
                                ref={chaptersRef}
                                className={`chapters-text-container ${isChaptersExpanded ? 'expanded' : 'collapsed'}`}
                            >
                                {/* Chapters: {resultdata[0].chapters.map((c: any) => {
                                    const chapterName = c.chapterName || c.ChapterName;
                                    const validTopics = c.topics?.filter((t: any) => t && t.toLowerCase() !== 'null' && t.trim() !== '') || [];
                                    const topics = validTopics.length > 0 ? ` (${validTopics.join(', ')})` : '';
                                    return `${chapterName}${topics}`;
                                }).filter(Boolean).join(', ')} */}
                                {t("chapters")}: {chapterTopics.map((c: any) => {
                                    const chapterName = c.chapter;
                                    const validTopics = c.topics?.map((t: any) => t.topic)?.filter((t: any) => t && t.toLowerCase() !== 'null' && t.trim() !== '') || [];
                                    const topics = validTopics.length > 0 ? ` (${validTopics.join(', ')})` : '';
                                    return `${chapterName}${topics}`;
                                }).filter(Boolean).join(', ')}
                            </div>
                            {showExpandButton && (
                                <span
                                    onClick={() => setIsChaptersExpanded(!isChaptersExpanded)}
                                    className="tw-text-purple-600 tw-cursor-pointer tw-font-semibold tw-text-xs hover:tw-underline tw-mt-1 tw-inline-block"
                                >
                                    {isChaptersExpanded ? 'Show Less' : 'Show More'}
                                </span>
                            )}

                        </div>
                    )}




                </div>


                {/* <div className="tw-col-span-1 md:tw-col-span-1 md:tw-text-right">
                    <div className="tw-flex tw-items-center md:tw-justify-end tw-gap-2" onClick={() => navigateToLeaderBoard()}>
                        <SvgIcon name="dashboard" size={16} />
                        <span style={{ color: 'var(--ia-primary)', cursor: 'pointer' }}>Leaderboard</span>
                    </div>
                </div> */}

            </div>

            <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-6 tw-gap-6">
                <div className="tw-col-span-1 lg:tw-col-span-3">
                    {/* {testType === 1 && */}
                    <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-6" style={{ height: "100%" }}>
                        <div className="custom-card tw-rounded-md tw-border tw-border-purple-300/50 shadow-none tw-bg-purple-100/50 px-3 py-2">
                            <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
                                <div style={{ width: "100%" }}>
                                    <div className="tw-text-lg tw-font-semibold tw-flex tw-flex-wrap tw-items-center  tw-gap-2 tw-mb-1">
                                        <span className="">{t("score")}</span>
                                        <span className="tw-inline-flex tw-items-center px-1 py-1  tw-rounded-full tw-text-xs tw-font-semibold tw-bg-purple-50 tw-text-purple-500 dark:bg-primary-100/20 dark:tw-text-primary-400 tw-border tw-border-purple-300 dark:tw-border-primary-500/30"><span className="tw-size-2 tw-inline-block tw-rounded-full tw-bg-purple-400 tw-mr-1"></span>{t("accuracy")}: {formatPercent(Number(accuracy))}%</span>
                                    </div>
                                    <span className="tw-text-2xl tw-font-semibold tw-text-purple-400">{resultdata[0] ? (resultdata[0]?.['totalMarks'] > 0 ? `${resultdata[0]?.['overAllMarks'] ? formatScore(resultdata[0]?.['overAllMarks']) : 0}/${formatScore(resultdata[0]?.['totalMarks'])}` : 0) : ''}</span>

                                </div>
                                {/* <div className="tw-text-purple-300">
                                    <SvgIcon name="globe" size={50} />
                                </div> */}
                            </div>
                            <div className="text-sm tw-rounded-3xl tw-bg-white px-3 py-1">{getScoreMessage()}</div>
                        </div>
                        <div className="custom-card tw-rounded-md tw-border tw-border-rose-300/50 shadow-none tw-bg-rose-100/50 px-3 py-2">
                            <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
                                <div style={{ width: "100%" }}>
                                    <div className="tw-text-lg tw-font-semibold tw-flex tw-flex-wrap tw-items-center  tw-gap-2 tw-mb-1">
                                        <span className="">{t("time_taken")}</span>
                                        <span className="tw-inline-flex tw-items-center px-1 py-1  tw-rounded-full tw-text-xs tw-font-semibold tw-bg-rose-50 tw-text-rose-500 dark:bg-primary-100/20 dark:tw-text-primary-400 tw-border tw-border-rose-300 dark:tw-border-primary-500/30"><span className="tw-size-2 tw-inline-block tw-rounded-full tw-bg-rose-400 tw-mr-1"></span>{t("utilization")}: {timeUtilization ? formatPercent(timeUtilization) : 0}%</span>
                                    </div>
                                    <span className="tw-text-2xl tw-font-semibold tw-text-rose-400">{resultdata[0] ? TimeValue : ''}/{duration ? getDuration(duration) : ""}</span>

                                </div>
                                {/* <div className="tw-text-rose-300">
                                    <SvgIcon name="time" size={50} />
                                </div> */}
                            </div>

                            <div className="text-sm tw-rounded-3xl tw-bg-white px-3 py-1">{getTimeMessage()}</div>

                        </div>
                        {/* Questions by Level - Single Card */}
                        <div className="custom-card tw-bg-white px-3 py-4" style={{ marginBottom: 0 }}>
                            <div className="tw-flex tw-items-start">
                                <div className="mr-3 tw-leading-none">
                                    <span className="icon-rounded purple">
                                        <SvgIcon name="question" size={20} />
                                    </span>
                                </div>
                                <div className="tw-flex-1">
                                    <div><small className="tw-text-lg tw-font-semibold">{t("questions")}: {testType === 1 ? resultdata[0]?.['NoOfQuestion'] : resultdata[0]?.['attendQuestion']}</small></div>
                                    <div>
                                        <small className="tw-text-lg tw-font-semibold">{t("total_marks")}: {resultdata[0]?.['totalMarks']}</small>
                                    </div>

                                    {/* <div className="tw-flex tw-items-start">
                                            <div className="mr-3 tw-leading-none">
                                                <span className="icon-rounded purple-light">
                                                    <SvgIcon name="mockTest" size={20} />
                                                </span>
                                            </div>
                                            <div>
                                            
                                            </div>
                                        </div> */}
                                    {/* <div className="tw-text-sm tw-text-gray-600 tw-mt-1"> */}
                                    {/* {resultdata[0]?.difficultyStats?.slice().sort((a: any, b: any) => a.DifficultyLevel - b.DifficultyLevel).map((stat: any, index: number) => (
                                                // <span key={index} className="tw-inline-flex tw-items-center px-2 py-1 tw-border tw-border-grey-400 tw-rounded-3xl tw-mr-2 mb-2">
                                                //     Level {stat.DifficultyLevel}:&nbsp; <span className="tw-font-bold">{stat.totalQuestion}</span>
                                                //     {/* {index < resultdata[0].difficultyStats.length - 1 ? ' | ' : ''} */}
                                    {/* // </span>
                                            ))} */}
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>



                        {/* Answered by Level - Single Card */}
                        <div className="custom-card tw-bg-white px-3 py-4" style={{ marginBottom: 0 }}>
                            <div className="tw-flex tw-items-start">
                                <div className="mr-3 tw-leading-none">
                                    <span className="icon-rounded green">
                                        <SvgIcon name="testCompleted" size={20} />
                                    </span>
                                </div>
                                <div className="tw-flex-1">
                                    <div>    <small className="tw-text-lg tw-font-semibold">{t("attempted")}: {resultdata[0]?.['attendQuestion']}</small></div>

                                    {
                                        testType === 1 && <div> <small className="tw-text-lg tw-font-semibold">{t("skipped")}: {resultdata[0] ? (resultdata[0]?.['NoOfQuestion']) - (resultdata[0]?.['attendQuestion']) : ''}</small></div>
                                    }

                                    {/* {resultdata[0]?.['attendQuestion'] > 0 && (
                                            <div className="tw-text-sm tw-text-gray-600 tw-mt-1">
                                                {resultdata[0]?.difficultyStats?.slice().sort((a: any, b: any) => a.DifficultyLevel - b.DifficultyLevel).map((stat: any, index: number) => (
                                                    <span key={index} className="tw-inline-flex tw-items-center px-2 py-1 tw-border tw-border-grey-400 tw-rounded-3xl tw-mr-2 mb-2">
                                                        Level {stat.DifficultyLevel}:&nbsp; <span className="tw-font-bold">{stat.answeredQuestion}</span>
                                                    </span>
                                                ))}
                                            </div>
                                        )} */}
                                    {
                                        testType === 1 && (
                                            <div className="tw-mt-2 tw-font-semibold">{getAttemptedMessage()}</div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>


                        {/* <div className="custom-card tw-bg-white px-3 py-4">
                                <div className="tw-flex tw-items-start">
                                    <div className="mr-3 tw-leading-none">
                                        <span className="icon-rounded purple-light">
                                            <SvgIcon name="mockTest" size={20} />
                                        </span>
                                    </div>
                                    <div>
                                    
                                        <div className="tw-mt-2 tw-font-semibold">{getSkipMessage()}</div>
                                    </div>
                                </div>
                            </div> */}

                        <div className="custom-card tw-bg-white px-3 py-4" style={{ marginBottom: 0 }}>
                            <div className="tw-flex tw-items-start">
                                <div className="mr-3 tw-leading-none">
                                    <span className="icon-rounded green">
                                        <SvgIcon name="testCompleted" size={20} />
                                    </span>
                                </div>
                                <div>
                                    <small className="tw-text-lg tw-font-semibold">{t("correct")}: {resultdata[0]?.['correctAns']}</small>
                                    {/* {resultdata[0]?.['attendQuestion'] > 0 && resultdata[0]?.['correctAns'] > 0 && (
                                            <div className="tw-text-sm tw-text-gray-600 tw-mt-1">
                                                {resultdata[0]?.difficultyStats?.slice().sort((a: any, b: any) => a.DifficultyLevel - b.DifficultyLevel).map((stat: any, index: number) => (
                                                    <span key={index} className="tw-inline-flex tw-items-center px-2 py-1 tw-border tw-border-grey-400 tw-rounded-3xl tw-mr-2 mb-2">
                                                        Level {stat.DifficultyLevel}:&nbsp; <span className="tw-font-bold">{stat.correctQuestion}</span>
                                                    </span>
                                                ))}
                                            </div>
                                        )} */}
                                    {
                                        attemptRate > 0 && <div className="tw-mt-2 tw-font-semibold">{getCorrectMessage()}</div>
                                    }

                                </div>
                            </div>
                        </div>

                        <div className="custom-card tw-bg-white px-3 py-4 " style={{ marginBottom: 0 }}>
                            <div className="tw-flex tw-items-start">
                                <div className="mr-3 tw-leading-none">
                                    <span className="icon-rounded purple">
                                        <SvgIcon name="testPending" size={20} />
                                    </span>
                                </div>
                                <div>
                                    <small className="tw-text-lg tw-font-semibold">{t("incorrect")}: {resultdata[0]?.['incorrectAns']}</small>
                                    {/* {resultdata[0]?.['attendQuestion'] > 0 && resultdata[0]?.['incorrectAns'] > 0 && (
                                            <div className="tw-text-sm tw-text-gray-600 tw-mt-1">
                                                {resultdata[0]?.difficultyStats?.slice().sort((a: any, b: any) => a.DifficultyLevel - b.DifficultyLevel).map((stat: any, index: number) => (
                                                    <span key={index} className="tw-inline-flex tw-items-center px-2 py-1 tw-border tw-border-grey-400 tw-rounded-3xl tw-mr-2 mb-2">
                                                        Level {stat.DifficultyLevel}:&nbsp; <span className="tw-font-bold">{stat.incorrectQuestion}</span>
                                                    </span>
                                                ))}
                                            </div>
                                        )} */}
                                    {
                                        attemptRate > 0 && <div className="tw-mt-2 tw-font-semibold">{getIncorrectMessage()}</div>
                                    }
                                </div>
                            </div>
                        </div>

                    </div>
                    {/* } */}
                    {/* {testType === 2 && <div className="tw-grid tw-grid-cols-1 tw-gap-6">
                        <div className="custom-card tw-bg-white px-3 py-4">
                            <div className="tw-flex tw-items-start">
                                <div className="mr-3 tw-leading-none">
                                    <span className="icon-rounded purple">
                                        <SvgIcon name="mockTest" size={20} />
                                    </span>
                                </div>
                                <div className="tw-flex-1">
                                    <small className="tw-text-lg tw-font-semibold">Attempted</small>
                                    <h3 className="tw-text-3xl tw-font-semibold tw-leading-none tw-mt-2">{resultdata[0]?.["attendQuestion"]}</h3>
                                    {resultdata[0]?.["attendQuestion"] > 0 && (
                                        <div className="tw-text-sm tw-text-gray-600 tw-mt-1">
                                            {resultdata[0]?.difficultyStats?.slice().sort((a: any, b: any) => a.DifficultyLevel - b.DifficultyLevel).map((stat: any, index: number) => (
                                                <span key={index} className="tw-inline-flex tw-items-center px-2 py-1 tw-border tw-border-grey-400 tw-rounded-3xl tw-mr-2 mb-2">
                                                    Level {stat.DifficultyLevel}:&nbsp; <span className="tw-font-bold">{stat.answeredQuestion}</span>
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="custom-card tw-bg-white px-3 py-4">
                            <div className="tw-flex tw-items-start">
                                <div className="mr-3 tw-leading-none">
                                    <span className="icon-rounded green">
                                        <SvgIcon name="testCompleted" size={20} />
                                    </span>
                                </div>
                                <div>
                                    <small className="tw-text-lg tw-font-semibold">Correct</small>
                                    <h3 className="tw-text-3xl tw-font-semibold tw-leading-none">{resultdata[0]?.['correctAns']} </h3>
                                    {resultdata[0]?.['attendQuestion'] > 0 && resultdata[0]?.['correctAns'] > 0 && (
                                        <div className="tw-text-sm tw-text-gray-600 tw-mt-1">
                                            {resultdata[0]?.difficultyStats?.slice().sort((a: any, b: any) => a.DifficultyLevel - b.DifficultyLevel).map((stat: any, index: number) => (
                                                <span key={index} className="tw-inline-flex tw-items-center px-2 py-1 tw-border tw-border-grey-400 tw-rounded-3xl tw-mr-2 mb-2">
                                                    Level {stat.DifficultyLevel}:&nbsp; <span className="tw-font-bold">{stat.correctQuestion}</span>
                                                </span>
                                            ))}
                                        </div>

                                    )}
                                    {
                                        attemptRate > 0 && <div className="tw-mt-2 tw-font-semibold">{getCorrectMessage()}</div>
                                    }

                                </div>
                            </div>
                        </div>

                        <div className="custom-card tw-bg-white px-3 py-4">
                            <div className="tw-flex tw-items-start">
                                <div className="mr-3 tw-leading-none">
                                    <span className="icon-rounded purple-light">
                                        <SvgIcon name="testPending" size={20} />
                                    </span>
                                </div>
                                <div>
                                    <small className="tw-text-lg tw-font-semibold">Incorrect</small>
                                    <h3 className="tw-text-3xl tw-font-semibold tw-leading-none">{resultdata[0]?.['incorrectAns']}</h3>
                                    {resultdata[0]?.['attendQuestion'] > 0 && resultdata[0]?.['incorrectAns'] > 0 && (
                                        <div className="tw-text-sm tw-text-gray-600 tw-mt-1">
                                            {resultdata[0]?.difficultyStats?.slice().sort((a: any, b: any) => a.DifficultyLevel - b.DifficultyLevel).map((stat: any, index: number) => (
                                                <span key={index} className="tw-inline-flex tw-items-center px-2 py-1 tw-border tw-border-grey-400 tw-rounded-3xl tw-mr-2 mb-2">
                                                    Level {stat.DifficultyLevel}:&nbsp; <span className="tw-font-bold">{stat.incorrectQuestion}</span>
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                    {
                                        attemptRate > 0 && <div className="tw-mt-2 tw-font-semibold">{getIncorrectMessage()}</div>
                                    }

                                </div>
                            </div>
                        </div>

                    </div>} */}
                    {/* <div className="custom-card tw-bg-white px-4 py-4 mt-4">
                        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-6 mt-0"> */}
                    {/* <div className="custom-card tw-rounded-md tw-border tw-border-blue-300 tw-hover:shadow-lg tw-hover:scale-105 tw-transition-transform  tw-duration-200 tw-bg-blue-100 hover:tw-bg-blue-200 px-3 py-2" style={{ cursor: "pointer" }} onClick={() => navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.SKILL_ANALYTICS}`, { state: { userTestId: userTestId, testName: resultdata[0].Name } })} >
                                <div className="tw-flex tw-items-center tw-justify-between">
                                    <div style={{ width: "100%" }} >
                                        <div className="tw-text-lg tw-text-gray-700 tw-font-semibold">Find your weak skills </div>
                                        <div className="tw-text-sm tw-font-semibold">See where you are losing marks </div>



                                    </div>
                                    <div className="tw-text-rose-300">
                                        <FontAwesomeIcon icon={faArrowTrendUp} style={{ color: "#417cf263", fontSize: "40px" }} />
                                    </div>
                                    {/* <div className="tw-text-orange-300">
                                        <SvgIcon name="crown" size={50} />
                                    </div> */}
                    {/* </div> */}
                    {/* <div className="tw-text-lg tw-font-semibold text-right"> <FontAwesomeIcon icon={faPlus} style={{ color: "#7f6ae8" }} /> </div> */}
                    {/* <div className="tw-text-sm tw-text-blue-500 tw-font-semibold text-left my-2">View Analysis <SvgIcon name="rightArrow" size={12} /> </div> */}

                    {/* </div> */}

                    {/* <div className="custom-card tw-rounded-md tw-border tw-border-pink-300 tw-hover:shadow-lg tw-hover:scale-105 tw-transition-transform  tw-duration-200 tw-bg-pink-100 hover:tw-bg-pink-200 px-3 py-2" style={{ cursor: "pointer" }} onClick={() => navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TOPIC_ANALYTICS}`, { state: { userTestId: userTestId, testName: resultdata[0].Name } })} >
                                <div className="tw-flex tw-items-center tw-justify-between">
                                    <div style={{ width: "100%" }} >
                                        <div className="tw-text-lg tw-text-gray-700 tw-font-semibold">Find your weak topics </div>
                                        <div className="tw-text-sm tw-font-semibold">See which topics you are struggling with </div>


                                    </div>
                                    <div className="tw-text-rose-300">
                                        <FontAwesomeIcon icon={faArrowTrendUp} style={{ color: "#da41f263", fontSize: "40px" }} />
                                    </div>
                                </div>
                                <div className="tw-text-sm tw-text-pink-500 tw-font-semibold text-left my-2">View Analysis <SvgIcon name="rightArrow" size={12} /> </div>
                            </div> */}
                    {/* </div>
                    </div> */}
                </div>

                <div className="tw-col-span-1 lg:tw-col-span-3" style={{ height: "100%" }}>
                    <div className="custom-card tw-bg-white px-4 py-4" style={{ height: "100%" }}>
                        {/* <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-6 mt-0"> */}
                        {/* <div className="custom-card tw-rounded-md tw-border tw-border-orange-300/50 shadow-none tw-bg-orange-100/50 px-3 py-2">
                                <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
                                    <div>
                                        <div className="tw-text-lg tw-font-semibold">Rank</div>
                                        <span className="tw-text-3xl tw-font-semibold tw-text-orange-400">{LeaderDetails ? (rankvalue + 1) : ''}</span>

                                    </div>
                                    <div className="tw-text-orange-300">
                                        <SvgIcon name="crown" size={50} />
                                    </div>
                                </div>
                                {
                                    rankvalue + 1 > 1 && <div className="tw-text-orange-400 text-sm tw-rounded-3xl tw-bg-white px-3 py-1">Focus on accuracy to improve rank</div>
                                }
                            </div> */}


                        {/* </div> */}
                        {(examType === 1 || examType === 3) &&
                            (resultdata[0]?.YourRank ? (
                                <div className="tw-bg-purple-50 tw-p-2 tw-mb-3 tw-border border-purple-500 tw-rounded-xl">
                                    <div className="tw-flex tw-justify-center tw-w-full tw-text-sm tw-font-bold tw-text-purple-600 tw-mb-1" style={{ width: "100%" }}>
                                        Your Predicted Rank
                                    </div>
                                    <div className="tw-flex tw-justify-center tw-w-full tw-text-4xl tw-font-bold tw-text-purple-600 " style={{ width: "100%" }}>
                                        {resultdata[0].YourRank}
                                    </div>
                                </div>) :
                                (
                                    <div className="tw-bg-purple-50 tw-p-2 tw-mb-3 tw-border border-purple-500 tw-rounded-xl">
                                        <div className="tw-flex tw-justify-center tw-w-full tw-text-sm tw-font-bold tw-text-purple-600 tw-mb-1" style={{ width: "100%" }}>
                                            No Predicted Rank Available For Your Score
                                        </div>

                                    </div>)

                            )}
                        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4 ">

                            <div className="tw-rounded-md tw-col-span-1 sm:tw-col-span-2 tw-border tw-border-grey-100 tw-bg-white px-3 py-3 tw-justify-center">

                                <div className="tw-flex tw-items-center tw-justify-center">

                                    <div className="tw-text-center">

                                        <h3 className="tw-text-yellow-700 tw-font-bold tw-leading-none text-center">
                                            {getPerformanceAdvice()}
                                        </h3>
                                    </div>

                                </div>


                            </div>

                            {/* start new section */}
                            <div className="tw-mt-2 tw-col-span-1 sm:tw-col-span-2">
                                <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-6 mt-0">
                                    <div className="custom-card shadow-none tw-rounded-md tw-border tw-border-blue-300/50 tw-bg-blue-100/50 px-3 py-2" >
                                        <div className="tw-flex tw-items-center tw-justify-between">
                                            <div style={{ width: "100%" }} >
                                                <div className="tw-text-lg tw-text-gray-700 tw-font-semibold">{!(TestResultPercent === 100) ? t("why_you_lost_marks") : t("performance_highlights")}</div>
                                                <div className="tw-text-sm tw-font-semibold">{!(TestResultPercent === 100) ? t("whats_holding_your_score_back") : t("key_strengths_in_this_test")}</div>

                                                <div className="tw-text-grey-300 text-sm mt-3">{getInsights()}</div>


                                            </div>

                                        </div>


                                    </div>

                                    <div className="custom-card shadow-none tw-rounded-md tw-border tw-border-pink-300 tw-bg-pink-100 px-3 py-2" >
                                        <div className="tw-flex tw-items-center tw-justify-between">
                                            <div style={{ width: "100%" }} >
                                                <div className="tw-text-lg tw-text-gray-700 tw-font-semibold">{t("what_to_do_next")}</div>
                                                {
                                                    !(TestResultPercent === 100) && <div className="tw-text-sm tw-font-semibold">{t("your_next_step_to_improve")}</div>
                                                }



                                            </div>

                                        </div>
                                        <div className="tw-text-xs tw-mt-4">
                                            <ul>

                                                {/* <li className="tw-mt-1 tw-border tw-border-pink-300/50 tw-bg-pink-100/10 hover:tw-bg-pink-200 tw-rounded-md px-2 py-2 hover:tw-shadow-2xl tw-transition-shadow tw-transition-transform  tw-duration-200">
                                                        <span className="tw-text-sm tw-text-gray-700"> Practice targeted questions</span>
                                                        <div
                                                            className="tw-text-pink-500 tw-text-sm tw-transition-colors tw-font-semibold tw-flex tw-items-center tw-gap-1 tw-mt-1 cursor-pointer"
                                                            onClick={() => {
                                                                if (subjectList.length > 1) {
                                                                    navigate(`${TestSereisRouteURL.TEST_SERIES}`);
                                                                } else {
                                                                    const board = coursePreferences?.boardDetails?.[0];
                                                                    const classDetail = coursePreferences?.classDetails?.[0];
                                                                    const subName = resultdata[0]?.chapters[0]?.subjectName;
                                                                    const subId = resultdata[0]?.chapters[0]?.subjectId;
                                                                    const chapterName = resultdata[0]?.chapters[0]?.chapterName;
                                                                    const chapterId = resultdata[0]?.chapters[0]?.chapterId;
                                                                    const topicName = resultdata[0]?.chapters[0]?.topics[0]?.topicName;
                                                                    const topicId = resultdata[0]?.chapters[0]?.topics[0]?.topicId;
                                                                    navigate(`${TestSereisRouteURL.TEST_SERIES}`, {
                                                                        state: {
                                                                            boardId: board?.Id,
                                                                            boardName: board?.Name,
                                                                            classId: classDetail?.Id,
                                                                            className: classDetail?.Name,
                                                                            subjectId: subId,
                                                                            subjectName: subName,
                                                                            chapterId: chapterId,
                                                                            chapterName: chapterName,
                                                                            topicId: topicId,
                                                                            topicName: topicName,
                                                                            topicPriority: 1
                                                                        }
                                                                    })
                                                                }

                                                            }}
                                                        >
                                                            Improve accuracy <SvgIcon name="rightArrow" size={14} />
                                                        </div>
                                                    </li> */}
                                                <li className="tw-mt-1 tw-border tw-border-pink-300/50 tw-bg-red-700 hover:tw-bg-white tw-rounded-md px-2 py-2 tw-shadow-lg hover:tw-shadow-2xl tw-transition-shadow tw-transition-transform  tw-duration-200 tw-text-white hover:tw-text-pink-700">
                                                    {/* <span className="tw-text-sm tw-text-gray-700">Find your weak topics </span> */}
                                                    <div

                                                        className="tw-text-sm tw-font-semibold tw-flex tw-items-center tw-justify-between tw-gap-1  cursor-pointer"
                                                        onClick={() => navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TOPIC_ANALYTICS}`, { state: { userTestId: userTestId, testName: testName } })}
                                                    >
                                                        {t("topics_you_are_struggling_with")} <SvgIcon name="rightArrow" size={14} />
                                                    </div>
                                                </li>
                                                <li className="tw-mt-1 tw-border tw-border-pink-300/50 tw-bg-red-700 hover:tw-bg-white tw-rounded-md px-2 py-2 tw-shadow-lg hover:tw-shadow-2xl tw-transition-shadow tw-transition-transform  tw-duration-200 tw-text-white hover:tw-text-pink-700">
                                                    {/* <span className="tw-text-sm tw-text-gray-700"> Find your weak skills</span> */}
                                                    <div

                                                        className="tw-text-sm tw-font-semibold tw-flex tw-items-center tw-justify-between tw-gap-1  cursor-pointer"
                                                        onClick={() => navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.SKILL_ANALYTICS}`, { state: { userTestId: userTestId, testName: testName } })}
                                                    >
                                                        {t("score_leak_areas_(skill_gaps)")} <SvgIcon name="rightArrow" size={14} />
                                                    </div>
                                                </li>
                                                {/* <li className="tw-mt-1 tw-border tw-border-pink-300/50 tw-bg-pink-200 hover:tw-bg-white tw-rounded-md px-2 py-2 hover:tw-shadow-2xl tw-transition-shadow tw-transition-transform  tw-duration-200">
                                                 
                                                    <div
                                                        onClick={() => navigation(`${AppRouteURL.VIDEO_LISTING}`, {
                                                            state: {
                                                                subjectList: subjectList?.map((s: any) => ({ Id: s.id, Name: s.name })), chapterList: chapterTopics?.map((c: any) => ({ Id: c.chapterId, Name: c.chapter })), topicList: chapterTopics?.flatMap((c: any) => {
                                                                    return c.topics.map((t: any) => ({ Id: t.topicId, Name: t.topic }))
                                                                }

                                                                )
                                                            }
                                                        })}
                                                        className="tw-text-pink-700 tw-text-sm tw-transition-colors tw-font-semibold tw-flex tw-items-center tw-justify-between tw-gap-1 cursor-pointer"
                                                    >
                                                        {t("watch_concept_videos")} <SvgIcon name="rightArrow" size={14} />
                                                    </div>
                                                </li> */}

                                                <li className="tw-mt-1 tw-border tw-border-pink-300/50 tw-bg-pink-200 hover:tw-bg-white tw-rounded-md px-2 py-2 hover:tw-shadow-2xl tw-transition-shadow tw-transition-transform  tw-duration-200">
                                                    {/* <span className="tw-text-sm tw-text-gray-700"> Retest</span> */}
                                                    <div

                                                        className="tw-text-pink-700 tw-text-sm tw-transition-colors tw-font-semibold tw-flex tw-items-center tw-justify-between tw-gap-1  cursor-pointer"
                                                        onClick={() => onClickRetry((examId ? examId : testId), testType, duration / 60, testseriesId, examType)}
                                                    >
                                                        {t("take_this_test_again")} <SvgIcon name="rightArrow" size={14} />
                                                    </div>
                                                </li>
                                                <li className="tw-mt-1 tw-border tw-border-pink-300/50 tw-bg-pink-200 hover:tw-bg-white tw-rounded-md px-2 py-2 hover:tw-shadow-2xl tw-transition-shadow tw-transition-transform  tw-duration-200">
                                                    {/* <span className="tw-text-sm tw-text-gray-700"> Retest</span> */}
                                                    <div

                                                        className="tw-text-pink-700 tw-text-sm tw-transition-colors tw-font-semibold tw-flex tw-items-center tw-justify-between tw-gap-1  cursor-pointer"
                                                        onClick={navigateToMindMap}
                                                    >
                                                        {t("visit_resvision_hub")} <SvgIcon name="rightArrow" size={14} />
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* End new section */}

                            {/* <div className="custom-card tw-rounded-md tw-border tw-border-green-300/50 shadow-none tw-bg-green-100/50 px-3 py-3">
                                <div className="tw-flex tw-items-center tw-justify-between">
                                    <div>
                                        <div className="tw-text-lg tw-font-semibold">Total Attempts</div>
                                        <span className="tw-text-3xl tw-font-semibold tw-text-green-400">{resultdata[0]?.['attempt']}</span>
                                    </div>
                                    <div className="tw-text-green-300">
                                        <SvgIcon name="testCompleted" size={50} />
                                    </div>
                                </div>

                            </div> */}



                        </div>
                    </div>

                </div>

            </div>




            <NoSubscriptionDialog {...subscriptionDialogProps} />
            <Dialog
                visible={pendingTestDialogProps.visible}
                onHide={pendingTestDialogProps.onHide}
                header="Pending Test"
                style={{ width: '420px' }}
                modal
                draggable={false}
                resizable={false}
                closable={true}
            >
                <div className="tw-text-center tw-py-2">
                    <p className="tw-text-base tw-mb-1">You have a pending test:</p>
                    <p className="tw-font-semibold tw-text-lg tw-mb-4" style={{ color: 'var(--ia-primary)' }}>
                        {pendingTestDialogProps.pendingTest?.TestSeriesName}
                    </p>
                    <p className="tw-text-sm tw-text-gray-500 tw-mb-6">
                        Please complete your pending test before starting a new one. For more details, check your test activity on My Test.
                    </p>
                    <div className="tw-flex tw-justify-center">
                        <button
                            className="ia-btn ia-btn-primary py-2 px-5"
                            onClick={pendingTestDialogProps.onContinue}
                        >
                            Go To My Test
                        </button>
                    </div>
                </div>
            </Dialog>
        </>)
}